// extracted by mini-css-extract-plugin
module.exports =  {"root":"P4AWBeMbIZhYFU4H2n8m"};